import { City } from '@/interfaces/CustomerInterface/CustomerInterface';
import { getCitiesByPostalCode } from '@/redux/eDniModal/eDniModalAPI';

export const getRoadType = (type: string) => {
  switch (type) {
    case 'Alameda o Aldea':
    case 'Alameda':
    case 'Aldea':
      return 'AL';
    case 'Apartamento':
      return 'AP';
    case 'Avenida':
      return 'AV';
    case 'Bloque':
      return 'BL';
    case 'Barrio':
      return 'BO';
    case 'Chalet':
      return 'CH';
    case 'Calle':
    case 'Carrer':
      return 'CL';
    case 'Camino':
      return 'CM';
    case 'Colonia':
      return 'CO';
    case 'Carretera':
      return 'CR';
    case 'Caserío':
      return 'CS';
    case 'Cuesta':
      return 'CT';
    case 'Edificio':
      return 'ED';
    case 'Glorieta':
      return 'GL';
    case 'Grupo':
      return 'GR';
    case 'Lugar':
      return 'LG';
    case 'Mercado':
      return 'MC';
    case 'Municipio':
      return 'AV';
    case 'Manzana':
      return 'MZ';
    case 'Poblado':
      return 'PB';
    case 'Polígono':
      return 'PG';
    case 'Pasaje':
      return 'PJ';
    case 'Parque':
      return 'PQ';
    case 'Plaza':
      return 'PZ';
    case 'Prolongación':
      return 'PR';
    case 'Paseo':
      return 'PS';
    case 'Rambla':
      return 'RB';
    case 'Ronda':
      return 'RD';
    case 'Travesía':
      return 'TR';
    case 'Urbanización':
      return 'UR';
    default:
      return 'ZZ';
  }
};

export const blockCharactersNoDecimal = (event: KeyboardEvent) => {
  const invalidChars = ['-', '+', 'e', 'E', '.', ','];
  if (invalidChars.includes(event.key)) {
    return event.preventDefault();
  }
};

export const blockCharacters = (e: any) => {
  const invalidChars = ['-', '+', 'e', 'E'];
  const controlKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Home',
    'End',
  ];
  if (
    invalidChars.includes(e.key)
    || (e.target?.value
      && e.target.value.length >= 7
      && !controlKeys.includes(e.key))
  ) {
    return e.preventDefault();
  }
};

export const getCity = async (postalCode: string): Promise<City[]> => {
  try {
    const cities = await getCitiesByPostalCode(postalCode);
    if (cities.length > 0) {
      return cities;
    }
    return [];
  } catch (error) {
    return [];
  }
};
